export default __webpack_public_path__ + "static/media/compliance.f6ee3e5e.webp";